var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-upload",
    "data-name": "Icon awesome-file-upload",
    d: "M8.75,5.313V0H.938A.935.935,0,0,0,0,.938V19.062A.935.935,0,0,0,.938,20H14.063A.935.935,0,0,0,15,19.062V6.25H9.688A.94.94,0,0,1,8.75,5.313ZM11.3,13.75H8.75v3.125a.625.625,0,0,1-.625.625H6.875a.625.625,0,0,1-.625-.625V13.75H3.7a.625.625,0,0,1-.44-1.069L7.03,8.943a.666.666,0,0,1,.939,0l3.766,3.738A.625.625,0,0,1,11.3,13.75ZM14.727,4.1,10.9.273A.937.937,0,0,0,10.238,0H10V5h5V4.762A.935.935,0,0,0,14.727,4.1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.809f54353f491265fab7e53d4f7061c3.svg";
export { ForwardRef as ReactComponent };